import { X } from 'lucide-react';
import React from 'react';
import ReactDOM from 'react-dom';
import '../../styles/components/custom-modal.scss';

const modalRoot = document.getElementById('modal-root');

export class CustomModal extends React.Component {
  componentDidMount() {
    // Prevent background scroll
    if (this.props.isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      document.body.style.overflow = 'hidden';
    } else if (!this.props.isOpen && prevProps.isOpen) {
      document.body.style.overflow = 'auto';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    const { isOpen, onClose, children, header, footer, closeBtn = true } = this.props;

    if (!isOpen) return null;

    return ReactDOM.createPortal(
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content-new" onClick={(e) => e.stopPropagation()}>
          {header && (
            <div className="modal-header">
              <div className="modal-header-content">{header}</div>
              {closeBtn && (
                <button className="modal-close" onClick={onClose}>
                  <X />
                </button>
              )}
            </div>
          )}

          <div className="modal-inner-scroll">{children}</div>

          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>,
      modalRoot
    );
  }
}
